// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wave-surfer-player_wrapper__oWg2_","image":"wave-surfer-player_image__whMxW"};